import css from 'styled-jsx/css';

const styles = css.global`#boleto-venceu-contrato {
  padding: 0 0 72px;
}

#boleto-venceu-contrato .boleto-venceu-desk {
  display: none;
}

#boleto-venceu-contrato picture, 
#boleto-venceu-contrato .img-boleto-venceu {
  width: 100%;
  height: 497px;
  object-fit: cover;
  object-position: top;
  border-radius: 4px;
}

#boleto-venceu-contrato .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 32px;
}

#boleto-venceu-contrato .boleto-venceu-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0;
}

#boleto-venceu-contrato .boleto-venceu-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  max-width: 554px;
}

#boleto-venceu-contrato .boleto-venceu-texto a {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#boleto-venceu-contrato .boleto-venceu-texto b {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#boleto-venceu-contrato .boleto-venceu-texto.margin-extra {
  margin: 16px 0;
}

#boleto-venceu-contrato .passos-gerar-boleto {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#boleto-venceu-contrato .passo-gerar-boleto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

#boleto-venceu-contrato .passo-gerar-boleto b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
}

#boleto-venceu-contrato .passo-gerar-boleto a {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#boleto-venceu-contrato .btn-boleto-venceu {
  width: 272px;
  height: 48px;
  margin: 16px auto 0;
}

@media (min-width: 992px) {
  #boleto-venceu-contrato {
    padding: 56px 0;
  }

  #boleto-venceu-contrato .ctn-home-24 {
    padding-top: 0;
  }

  #boleto-venceu-contrato .boleto-venceu-mobi {
    display: none;
  }

  #boleto-venceu-contrato .btn-boleto-venceu {
    margin: unset;
  }

  #boleto-venceu-contrato .boleto-venceu-desk {
    display: block;
  }

  #boleto-venceu-contrato .boleto-venceu-desk-conteudo {
    width: 100%;
  }

  #boleto-venceu-contrato .boleto-venceu-desk .ctn-home-24 {
    display: flex;
    flex-direction: row;
    gap: 72px;
  }

  #boleto-venceu-contrato picture, 
  #boleto-venceu-contrato .img-boleto-venceu {
    height: 623px;
  }

  #boleto-venceu-contrato .boleto-venceu-titulo {
    font-size: 72px;
    line-height: 120%;
  }
  #boleto-venceu-contrato .boleto-venceu-texto {
    margin-top: 24px;
  }

  #boleto-venceu-contrato .passos-gerar-boleto {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 49px;
  }
  
  #boleto-venceu-contrato .passo-gerar-boleto b {
    color: #C00;
    font-family: "SantanderText";
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
  }

  #boleto-venceu-contrato .passo-gerar-boleto a {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
  }

  #boleto-venceu-contrato .btn-boleto-venceu {
    max-width: 100%;
    margin-top: 32px;
  }
}

@media (min-width: 1280px) {
  #boleto-venceu-contrato .boleto-venceu-desk .ctn-home-24 {
    max-width: 1280px;
  }
}`;

export default styles;